import { __ } from '@wordpress/i18n';
import {
  addCard,
  addSubmenu,
  alignCenter,
  alignJustify,
  alignLeft,
  alignNone,
  alignRight,
  archive,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  atSymbol,
  aspectRatio,
  audio,
  backup,
  blockDefault,
  blockTable,
  box,
  brush,
  bug,
  button,
  buttons,
  calendar,
  cancelCircleFilled,
  capturePhoto,
  captureVideo,
  category,
  chartBar,
  check,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronRightSmall,
  chevronUp,
  classic,
  close,
  closeSmall,
  cloudUpload,
  cloud,
  code,
  cog,
  color,
  column,
  columns,
  comment,
  commentAuthorAvatar,
  commentAuthorName,
  commentContent,
  commentReplyLink,
  cover,
  create,
  crop,
  currencyDollar,
  currencyEuro,
  currencyPound,
  customPostType,
  desktop,
  dragHandle,
  download,
  edit,
  external,
  file,
  flipHorizontal,
  flipVertical,
  formatBold,
  formatCapitalize,
  formatIndent,
  formatIndentRTL,
  formatItalic,
  formatListBullets,
  formatListBulletsRTL,
  formatListNumbered,
  formatListNumberedRTL,
  formatLtr,
  formatLowercase,
  formatOutdent,
  formatOutdentRTL,
  formatRtl,
  formatStrikethrough,
  formatUnderline,
  formatUppercase,
  fullscreen,
  gallery,
  globe,
  grid,
  group,
  handle,
  heading,
  help,
  helpFilled,
  inbox,
  institution,
  home,
  html,
  image,
  insertAfter,
  insertBefore,
  justifyLeft,
  justifyCenter,
  justifyRight,
  justifySpaceBetween,
  key,
  keyboardClose,
  keyboardReturn,
  layout,
  lifesaver,
  link,
  linkOff,
  list,
  listView,
  lock,
  login,
  loop,
  mapMarker,
  media,
  mediaAndText,
  megaphone,
  menu,
  mobile,
  more,
  moreHorizontal,
  moreHorizontalMobile,
  moreVertical,
  moveTo,
  navigation,
  overlayText,
  pageBreak,
  customLink,
  page,
  pages,
  paragraph,
  payment,
  percent,
  positionCenter,
  positionLeft,
  positionRight,
  pencil,
  people,
  pin,
  plugins,
  plusCircleFilled,
  plusCircle,
  plus,
  post,
  postAuthor,
  postCategories,
  postContent,
  postComments,
  postCommentsCount,
  postCommentsForm,
  postDate,
  postExcerpt,
  postFeaturedImage,
  postList,
  postTerms,
  previous,
  next,
  preformatted,
  pullLeft,
  pullRight,
  pullquote,
  queryPagination,
  queryPaginationNext,
  queryPaginationNumbers,
  queryPaginationPrevious,
  quote,
  receipt,
  redo,
  removeBug,
  removeSubmenu,
  replace,
  reset,
  resizeCornerNE,
  reusableBlock,
  rotateLeft,
  rotateRight,
  row,
  rss,
  search,
  separator,
  settings,
  share,
  shield,
  shortcode,
  siteLogo,
  stack,
  starEmpty,
  starFilled,
  starHalf,
  store,
  stretchFullWidth,
  styles,
  shipping,
  stretchWide,
  subscript,
  superscript,
  swatch,
  symbol,
  symbolFilled,
  tableColumnAfter,
  tableColumnBefore,
  tableColumnDelete,
  tableRowAfter,
  tableRowBefore,
  tableRowDelete,
  table,
  tag,
  termDescription,
  footer,
  header,
  sidebar,
  textColor,
  tablet,
  tip,
  title,
  tool,
  trash,
  trendingDown,
  trendingUp,
  typography,
  undo,
  ungroup,
  unlock,
  update,
  upload,
  verse,
  video,
  warning,
  widget,
} from '@wordpress/icons';

const setWordpressIconsObject = (iconDetails) => {
  const [name, title, icon] = iconDetails;
  return { name, title, icon };
};

const icons = [
  ['addCard', __('Add Card', 'b3rg'), addCard],
  ['addSubmenu', __('Add Submenu', 'b3rg'), addSubmenu],
  ['alignCenter', __('Align Center', 'b3rg'), alignCenter],
  ['alignJustify', __('Align Justify', 'b3rg'), alignJustify],
  ['alignLeft', __('Align Left', 'b3rg'), alignLeft],
  ['alignNone', __('Align None', 'b3rg'), alignNone],
  ['alignRight', __('Align Right', 'b3rg'), alignRight],
  ['archive', __('Archive', 'b3rg'), archive],
  ['arrowDown', __('Arrow Down', 'b3rg'), arrowDown],
  ['arrowLeft', __('Arrow Left', 'b3rg'), arrowLeft],
  ['arrowRight', __('Arrow Right', 'b3rg'), arrowRight],
  ['arrowUp', __('Arrow Up', 'b3rg'), arrowUp],
  ['atSymbol', __('At Symbol', 'b3rg'), atSymbol],
  ['aspectRatio', __('Aspect Ratio', 'b3rg'), aspectRatio],
  ['audio', __('Audio', 'b3rg'), audio],
  ['backup', __('Backup', 'b3rg'), backup],
  ['blockDefault', __('Block Default', 'b3rg'), blockDefault],
  ['blockTable', __('Block Table', 'b3rg'), blockTable],
  ['box', __('Box', 'b3rg'), box],
  ['brush', __('Brush', 'b3rg'), brush],
  ['bug', __('Bug', 'b3rg'), bug],
  ['button', __('Button', 'b3rg'), button],
  ['buttons', __('Buttons', 'b3rg'), buttons],
  ['calendar', __('Calendar', 'b3rg'), calendar],
  [
    'cancelCircleFilled',
    __('Cancel - Circle Filled', 'b3rg'),
    cancelCircleFilled,
  ],
  ['capturePhoto', __('Capture Photo', 'b3rg'), capturePhoto],
  ['captureVideo', __('Capture Video', 'b3rg'), captureVideo],
  ['category', __('Category', 'b3rg'), category],
  ['chartBar', __('Chart Bar', 'b3rg'), chartBar],
  ['check', __('Check', 'b3rg'), check],
  ['chevronDown', __('Chevron Down', 'b3rg'), chevronDown],
  ['chevronLeft', __('Chevron Left', 'b3rg'), chevronLeft],
  ['chevronRight', __('Chevron Right', 'b3rg'), chevronRight],
  ['chevronRightSmall', __('Chevron Right - Small', 'b3rg'), chevronRightSmall],
  ['chevronUp', __('Chevron Up', 'b3rg'), chevronUp],
  ['classic', __('Classic', 'b3rg'), classic],
  ['close', __('Add', 'Close'), close],
  ['closeSmall', __('Close - Small', 'b3rg'), closeSmall],
  ['cloudUpload', __('Cloud Upload', 'b3rg'), cloudUpload],
  ['cloud', __('Cloud', 'b3rg'), cloud],
  ['code', __('Code', 'b3rg'), code],
  ['cog', __('Cog', 'b3rg'), cog],
  ['color', __('Color', 'b3rg'), color],
  ['column', __('Column', 'b3rg'), column],
  ['columns', __('Columns', 'b3rg'), columns],
  ['comment', __('Comment', 'b3rg'), comment],
  [
    'commentAuthorAvatar',
    __('Comment Author Avatar', 'b3rg'),
    commentAuthorAvatar,
  ],
  ['commentAuthorName', __('Comment Author Name', 'b3rg'), commentAuthorName],
  ['commentContent', __('Comment Content', 'b3rg'), commentContent],
  ['commentReplyLink', __('Comment Reply Link', 'b3rg'), commentReplyLink],
  ['cover', __('Cover', 'b3rg'), cover],
  ['create', __('Create', 'b3rg'), create],
  ['crop', __('Crop', 'b3rg'), crop],
  ['currencyDollar', __('Currency Dollar', 'b3rg'), currencyDollar],
  ['currencyEuro', __('Currency Euro', 'b3rg'), currencyEuro],
  ['currencyPound', __('Currency Pound', 'b3rg'), currencyPound],
  ['customPostType', __('Custom Post Type', 'b3rg'), customPostType],
  ['desktop', __('Desktop', 'b3rg'), desktop],
  ['dragHandle', __('Drag Handle', 'b3rg'), dragHandle],
  ['download', __('Download', 'b3rg'), download],
  ['edit', __('Edit', 'b3rg'), edit],
  ['external', __('External', 'b3rg'), external],
  ['file', __('File', 'b3rg'), file],
  ['flipHorizontal', __('Flip Horizontal', 'b3rg'), flipHorizontal],
  ['flipVertical', __('Flip Vertical', 'b3rg'), flipVertical],
  ['formatBold', __('Format Bold', 'b3rg'), formatBold],
  ['formatCapitalize', __('Format Capitalize', 'b3rg'), formatCapitalize],
  ['formatIndent', __('Format Indent', 'b3rg'), formatIndent],
  ['formatIndentRTL', __('Format Indent RTL', 'b3rg'), formatIndentRTL],
  ['formatItalic', __('Format Italic', 'b3rg'), formatItalic],
  ['formatListBullets', __('Format List Bullets', 'b3rg'), formatListBullets],
  [
    'formatListBulletsRTL',
    __('Format List Bullets RTL', 'b3rg'),
    formatListBulletsRTL,
  ],
  [
    'formatListNumbered',
    __('Format List Numbered', 'b3rg'),
    formatListNumbered,
  ],
  [
    'formatListNumberedRTL',
    __('Format List Numbered RTL', 'b3rg'),
    formatListNumberedRTL,
  ],
  ['formatLtr', __('Format LTR', 'b3rg'), formatLtr],
  ['formatLowercase', __('Format Lowercase', 'b3rg'), formatLowercase],
  ['formatOutdent', __('Format Outdent', 'b3rg'), formatOutdent],
  ['formatOutdentRTL', __('Format Outdent RTL', 'b3rg'), formatOutdentRTL],
  ['formatRtl', __('Format RTL', 'b3rg'), formatRtl],
  [
    'formatStrikethrough',
    __('Format Strikethrough', 'b3rg'),
    formatStrikethrough,
  ],
  ['formatUnderline', __('Format Underline', 'b3rg'), formatUnderline],
  ['formatUppercase', __('Format Uppercase', 'b3rg'), formatUppercase],
  ['fullscreen', __('Fullscreen', 'b3rg'), fullscreen],
  ['gallery', __('Gallery', 'b3rg'), gallery],
  ['globe', __('Globe', 'b3rg'), globe],
  ['grid', __('Grid', 'b3rg'), grid],
  ['group', __('Group', 'b3rg'), group],
  ['handle', __('Handle', 'b3rg'), handle],
  ['heading', __('Heading', 'b3rg'), heading],
  ['help', __('Help', 'b3rg'), help],
  ['helpFilled', __('Help - Filled', 'b3rg'), helpFilled],
  ['inbox', __('Inbox', 'b3rg'), inbox],
  ['institution', __('Institution', 'b3rg'), institution],
  ['home', __('Home', 'b3rg'), home],
  ['html', __('HTML', 'b3rg'), html],
  ['image', __('Image', 'b3rg'), image],
  ['info', __('Info', 'b3rg'), addSubmenu],
  ['insertAfter', __('Insert After', 'b3rg'), insertAfter],
  ['insertBefore', __('Insert Before', 'b3rg'), insertBefore],
  ['justifyLeft', __('Justify Left', 'b3rg'), justifyLeft],
  ['justifyCenter', __('Justify Center', 'b3rg'), justifyCenter],
  ['justifyRight', __('Justify Right', 'b3rg'), justifyRight],
  [
    'justifySpaceBetween',
    __('Justify Space Between', 'b3rg'),
    justifySpaceBetween,
  ],
  ['key', __('Key', 'b3rg'), key],
  ['keyboardClose', __('Keyboard Close', 'b3rg'), keyboardClose],
  ['keyboardReturn', __('Keyboard Return', 'b3rg'), keyboardReturn],
  ['layout', __('Layout', 'b3rg'), layout],
  ['lifesaver', __('Lifesaver', 'b3rg'), lifesaver],
  ['link', __('Link', 'b3rg'), link],
  ['linkOff', __('Link Off', 'b3rg'), linkOff],
  ['list', __('List', 'b3rg'), list],
  ['listView', __('List View', 'b3rg'), listView],
  ['lock', __('Lock', 'b3rg'), lock],
  ['login', __('Login', 'b3rg'), login],
  ['loop', __('Loop', 'b3rg'), loop],
  ['mapMarker', __('Map Marker', 'b3rg'), mapMarker],
  ['media', __('Media', 'b3rg'), media],
  ['mediaAndText', __('Media & Text', 'b3rg'), mediaAndText],
  ['megaphone', __('Megaphone', 'b3rg'), megaphone],
  ['menu', __('Menu', 'b3rg'), menu],
  ['mobile', __('Mobile', 'b3rg'), mobile],
  ['more', __('More', 'b3rg'), more],
  ['moreHorizontal', __('More Horizontal', 'b3rg'), moreHorizontal],
  [
    'moreHorizontalMobile',
    __('More Horizontal - Mobile', 'b3rg'),
    moreHorizontalMobile,
  ],
  ['moreVertical', __('More Vertical', 'b3rg'), moreVertical],
  ['moveTo', __('Move To', 'b3rg'), moveTo],
  ['navigation', __('Navigation', 'b3rg'), navigation],
  ['overlayText', __('Overlay Text', 'b3rg'), overlayText],
  ['pageBreak', __('Page Break', 'b3rg'), pageBreak],
  ['customLink', __('Custom Link', 'b3rg'), customLink],
  ['page', __('Page', 'b3rg'), page],
  ['pages', __('Pages', 'b3rg'), pages],
  ['paragraph', __('Paragraph', 'b3rg'), paragraph],
  ['payment', __('Payment', 'b3rg'), payment],
  ['percent', __('Percent', 'b3rg'), percent],
  ['positionCenter', __('Position Center', 'b3rg'), positionCenter],
  ['positionLeft', __('Position Left', 'b3rg'), positionLeft],
  ['positionRight', __('Position Right', 'b3rg'), positionRight],
  ['post', __('Post', 'b3rg'), post],
  ['pencil', __('Pencil', 'b3rg'), pencil],
  ['people', __('People', 'b3rg'), people],
  ['pin', __('Pin', 'b3rg'), pin],
  ['plugins', __('Plugins', 'b3rg'), plugins],
  ['plusCircleFilled', __('Plus Circle - Filled', 'b3rg'), plusCircleFilled],
  ['plusCircle', __('Plus Circle', 'b3rg'), plusCircle],
  ['plus', __('Plus', 'b3rg'), plus],
  ['postAuthor', __('Post Author', 'b3rg'), postAuthor],
  ['postCategories', __('Post Categories', 'b3rg'), postCategories],
  ['postContent', __('Post Content', 'b3rg'), postContent],
  ['postComments', __('Post Comments', 'b3rg'), postComments],
  ['postCommentsCount', __('Post Comment Count', 'b3rg'), postCommentsCount],
  ['postCommentsForm', __('Post Comments Form', 'b3rg'), postCommentsForm],
  ['postDate', __('Post Date', 'b3rg'), postDate],
  ['postExcerpt', __('Post Excerpt', 'b3rg'), postExcerpt],
  ['postFeaturedImage', __('Post Featured Image', 'b3rg'), postFeaturedImage],
  ['postList', __('Post List', 'b3rg'), postList],
  ['postTerms', __('Post Terms', 'b3rg'), postTerms],
  ['previous', __('Previous', 'b3rg'), previous],
  ['next', __('Next', 'b3rg'), next],
  ['preformatted', __('Preformatted', 'b3rg'), preformatted],
  ['pullLeft', __('Pull Left', 'b3rg'), pullLeft],
  ['pullRight', __('Pull Right', 'b3rg'), pullRight],
  ['pullquote', __('Pull Quote', 'b3rg'), pullquote],

  ['queryPagination', __('Query Pagination', 'b3rg'), queryPagination],
  [
    'queryPaginationNext',
    __('Query Pagination Next', 'b3rg'),
    queryPaginationNext,
  ],
  [
    'queryPaginationNumbers',
    __('Query Pagination Numbers', 'b3rg'),
    queryPaginationNumbers,
  ],
  [
    'queryPaginationPrevious',
    __('Query Pagination Previous', 'b3rg'),
    queryPaginationPrevious,
  ],
  ['quote', __('Quote', 'b3rg'), quote],
  ['receipt', __('Receipt', 'b3rg'), receipt],
  ['redo', __('Redo', 'b3rg'), redo],
  ['removeBug', __('Remove Bug', 'b3rg'), removeBug],
  ['removeSubmenu', __('Remove Submenu', 'b3rg'), removeSubmenu],
  ['replace', __('Replace', 'b3rg'), replace],
  ['reset', __('Reset', 'b3rg'), reset],
  ['resizeCornerNE', __('Resize Corner', 'b3rg'), resizeCornerNE],
  ['reusableBlock', __('Reusable Block', 'b3rg'), reusableBlock],
  ['rotateLeft', __('Rotate Left', 'b3rg'), rotateLeft],
  ['rotateRight', __('Rotate Right', 'b3rg'), rotateRight],
  ['row', __('Row', 'b3rg'), row],
  ['rss', __('RSS', 'b3rg'), rss],
  ['search', __('Search', 'b3rg'), search],
  ['separator', __('Separator', 'b3rg'), separator],
  ['settings', __('Settings', 'b3rg'), settings],
  ['share', __('Share', 'b3rg'), share],
  ['shield', __('Shield', 'b3rg'), shield],
  ['shortcode', __('Short Code', 'b3rg'), shortcode],
  ['siteLogo', __('Site Logo', 'b3rg'), siteLogo],
  ['stack', __('Stack', 'b3rg'), stack],
  ['starEmpty', __('Star Empty', 'b3rg'), starEmpty],
  ['starFilled', __('Star Filled', 'b3rg'), starFilled],
  ['starHalf', __('Star Half', 'b3rg'), starHalf],
  ['store', __('Store', 'b3rg'), store],
  ['stretchFullWidth', __('Stretch Full Width', 'b3rg'), stretchFullWidth],
  ['styles', __('Styles', 'b3rg'), styles],
  ['shipping', __('Shipping', 'b3rg'), shipping],
  ['stretchWide', __('Stretch Wide', 'b3rg'), stretchWide],
  ['subscript', __('Subscript', 'b3rg'), subscript],
  ['superscript', __('Superscript', 'b3rg'), superscript],
  ['swatch', __('Swatch', 'b3rg'), swatch],
  ['symbol', __('Symbol', 'b3rg'), symbol],
  ['symbolFilled', __('Symbol - Filled', 'b3rg'), symbolFilled],
  ['tableColumnAfter', __('Table Column After', 'b3rg'), tableColumnAfter],
  ['tableColumnBefore', __('Table Column Before', 'b3rg'), tableColumnBefore],
  ['tableColumnDelete', __('Table Column Delete', 'b3rg'), tableColumnDelete],
  ['tableRowAfter', __('Table Row After', 'b3rg'), tableRowAfter],
  ['tableRowBefore', __('Table Row Before', 'b3rg'), tableRowBefore],
  ['tableRowDelete', __('Table Row Delete', 'b3rg'), tableRowDelete],
  ['table', __('Table', 'b3rg'), table],
  ['tag', __('Tag', 'b3rg'), tag],
  ['termDescription', __('Term Description', 'b3rg'), termDescription],
  ['footer', __('Footer', 'b3rg'), footer],
  ['header', __('Header', 'b3rg'), header],
  ['sidebar', __('Sidebar', 'b3rg'), sidebar],
  ['textColor', __('Text Color', 'b3rg'), textColor],
  ['tablet', __('Tablet', 'b3rg'), tablet],
  ['title', __('Title', 'b3rg'), title],
  ['tip', __('Tip', 'b3rg'), tip],
  ['tool', __('Tool', 'b3rg'), tool],
  ['trash', __('Trash', 'b3rg'), trash],
  ['trendingDown', __('Trending Down', 'b3rg'), trendingDown],
  ['trendingUp', __('Trending Up', 'b3rg'), trendingUp],
  ['typography', __('Typography', 'b3rg'), typography],
  ['undo', __('Undo', 'b3rg'), undo],
  ['ungroup', __('Ungroup', 'b3rg'), ungroup],
  ['unlock', __('Unlock', 'b3rg'), unlock],
  ['update', __('Update', 'b3rg'), update],
  ['upload', __('Upload', 'b3rg'), upload],
  ['verse', __('Verse', 'b3rg'), verse],
  ['video', __('Video', 'b3rg'), video],
  ['warning', __('Warning', 'b3rg'), warning],
  ['widget', __('Widget', 'b3rg'), widget],
];

const wordpressIcons = [];
icons.forEach((icon) => {
  wordpressIcons.push(setWordpressIconsObject(icon));
});

const getIcons = () => {
  return wordpressIcons;
};

export default getIcons;
